import {
  FETCH_SCOPE_LIST_SUCCESS,
  FETCH_SCOPE_LIST_FAILURE,
  EDIT_SCOPE_LIST_SUCCESS,
  EDIT_SCOPE_LIST_FAILURE,
  DELETE_SCOPED_FINDING_SUCCESS,
  DELETE_SCOPED_FINDING_FAILURE,
  FETCH_SCOPE_LIST_REQUEST
} from "../_constants";

const initialState = {
  loading: false,
  scopeList: "",
  error: "",
  deleteSuccess: false,
};

export const scopeListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SCOPE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        scopeList: '',
        deleteSuccess: false,
        error: "",
      };
    case FETCH_SCOPE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        scopeList: action.payload,
        deleteSuccess: false,
        error: "",
      };
    case FETCH_SCOPE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        scopeList: "",
        error: action.payload,
      };
    case EDIT_SCOPE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        scopeList: action.payload,
        error: "",
      };
    case EDIT_SCOPE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        scopeList: "",
        error: action.payload,
      };
    case DELETE_SCOPED_FINDING_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSuccess: true,
        error: "",
      };
    case DELETE_SCOPED_FINDING_FAILURE:
      return {
        ...state,
        loading: false,
        scopeList: "",
        error: action.payload,
      };
    default:
      return state;
  }
};
